import React from 'react'
import { Menu, Popover, useMenuContext } from '@chakra-ui/react'
import { Button, Stack, Box, SimplePopover, SubMenu } from '@/components/lib'

export default function ConfirmButton ({ header, body, footer, trigger, onConfirm, action, actionColor, closeOnBlur, asSubMenu }) {
  // When used inside a menu, this is the menu the trigger item lives in (the
  // submenu itself is opened below). Undefined when not rendered in a menu.
  const parentMenu = useMenuContext()

  // Always dismiss before acting: the action often removes the item the button
  // belongs to, and a still-open popover/menu then reattaches to whatever takes
  // its place in the list, inviting a second, accidental confirmation.
  const confirm = (dismiss) => () => {
    dismiss()
    if (onConfirm) onConfirm()
    if (action) action()
  }

  if (asSubMenu) {
    return (
      <SubMenu trigger={trigger}>
        <Menu.Context>
          {menu => (
            <Stack p={3}>
              {header && <Box fontWeight='bold'>{header}</Box>}
              {body && <Box>{body}</Box>}
              <Stack direction='row' justifyContent='end'>
                <Button
                  onClick={confirm(() => {
                    menu.setOpen(false)
                    if (parentMenu) parentMenu.setOpen(false)
                  })} colorPalette={actionColor || 'gray'}
                >Confirm
                </Button>
              </Stack>
              {footer && <Box textAlign='right'>{footer}</Box>}
            </Stack>
          )}
        </Menu.Context>
      </SubMenu>
    )
  }
  return (
    <SimplePopover
      closeOnBlur={closeOnBlur ?? true}
      trigger={trigger}
      header={header}
      body={
        <Popover.Context>
          {popover => (
            <Stack>
              {body && <Box>{body}</Box>}
              <Stack direction='row' justifyContent='end'>
                <Button
                  onClick={confirm(() => popover.setOpen(false))} colorPalette={actionColor || 'gray'}
                >Confirm
                </Button>
              </Stack>
            </Stack>
          )}
        </Popover.Context>
}
      footer={<Box textAlign='right'>{footer}</Box>}
    />
  )
}
